export interface AutoMessageCreateParams {
  platform?: General.PlatformUpperCase;
  name?: string;
  content?: string;
  enable?: boolean;
  cool_down_hour?: number;
  execute_time?: number;
  execute_time_unit?: 'MINUTE' | 'HOUR';
  limit_day?: number;
  limit_count?: number;
  filter_negative_buyer?: boolean;
  filter_consult?: boolean;
  filter_consult_days?: number;
  filter_wait_process_conversation?: boolean;
  filter_consult_after_create_order?: boolean;
  stores?: { id: number; region: General.UpperCaseRegion }[];
}
export const AUTO_MESSAGE_PLATFORMS = [
  'SHOPEE',
  'LAZADA',
  'TIKTOK',
  'TIKTOK_US',
  'TOKOPEDIA',
  'ALIEXPRESS',
  'MERCADO',
  'JOLECT',
] as const;
export function parseAutoMessageCreate(raw: unknown): AutoMessageCreateParams | undefined {
  if (!raw || typeof raw !== 'object' || Array.isArray(raw)) return;
  for (const [key, value] of Object.entries(raw)) {
    if (key === 'platform') {
      if (!AUTO_MESSAGE_PLATFORMS.includes(value as any)) return;
    } else if (key === 'name' || key === 'content') {
      if (typeof value !== 'string' || value.length > (key === 'name' ? 200 : 100000)) return;
    } else if (
      [
        'enable',
        'filter_negative_buyer',
        'filter_consult',
        'filter_wait_process_conversation',
        'filter_consult_after_create_order',
      ].includes(key)
    ) {
      if (typeof value !== 'boolean') return;
    } else if (
      [
        'cool_down_hour',
        'execute_time',
        'limit_day',
        'limit_count',
        'filter_consult_days',
      ].includes(key)
    ) {
      if (typeof value !== 'number' || !Number.isFinite(value) || value < 0) return;
    } else if (key === 'execute_time_unit') {
      if (value !== 'MINUTE' && value !== 'HOUR') return;
    } else if (key === 'stores') {
      if (
        !Array.isArray(value) ||
        value.some(
          (store) =>
            !store ||
            typeof store !== 'object' ||
            Object.keys(store).some((k) => !['id', 'region'].includes(k)) ||
            !Number.isSafeInteger(store.id) ||
            store.id < 1 ||
            typeof store.region !== 'string' ||
            !/^[A-Z]{2,3}$/.test(store.region),
        )
      )
        return;
    } else return;
  }
  return raw as AutoMessageCreateParams;
}
